/* unplugin-vue-components disabled */import { render } from "./PoliceEventListView.vue?vue&type=template&id=0a879d71&scoped=true"
import script from "./PoliceEventListView.vue?vue&type=script&lang=js"
export * from "./PoliceEventListView.vue?vue&type=script&lang=js"

import "./PoliceEventListView.vue?vue&type=style&index=0&id=0a879d71&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a879d71"]])

export default __exports__